import React from "react";

const CreatLockContext = React.createContext();

export default CreatLockContext;
